import { getFileExtForSport } from '@low6-pickem/sports-config';
import { isLowResImages, toLowResImageUrl } from './lowResImages';
import { toNonIpTeamImageUrl } from './leagueIp';

export function normalizeTeamLogoUrl(url: string): string {
  const normalized = normalizeExtension(url);
  // League IP off (DKPLAT-357): an NFL logo baked into the question by Admin is
  // licensed artwork, so swap it for the unlicensed team jersey. Applied before
  // the low-res step so the `-low` folder is picked from the final path.
  const ipResolved = toNonIpTeamImageUrl(normalized);
  // Low-res opt-in (DKPLAT-669): serve from the `-low` blob folder when a pickem
  // enables it. Applied here so every API-provided image URL is covered.
  return isLowResImages() ? toLowResImageUrl(ipResolved) : ipResolved;
}

function normalizeExtension(url: string): string {
  const match = url.match(/^(.*\/)([^/?#]+)\/teams\/([^/?#]+)\.([a-z0-9]+)([?#].*)?$/i);
  if (!match) {
    return url;
  }

  const [, prefix, sport, teamCode, currentExt, suffix = ''] = match;
  const expectedExt = getFileExtForSport(sport);

  if (currentExt.toLowerCase() === expectedExt) {
    return url;
  }

  return `${prefix}${sport}/teams/${teamCode}.${expectedExt}${suffix}`;
}
